import { render, staticRenderFns } from "./directSta.vue?vue&type=template&id=4d1fca48&scoped=true&"
import script from "./directSta.vue?vue&type=script&lang=js&"
export * from "./directSta.vue?vue&type=script&lang=js&"
import style0 from "./directSta.vue?vue&type=style&index=0&id=4d1fca48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1fca48",
  null
  
)

export default component.exports